// Prism - is a lightweight, extensible syntax highlighter, built with modern web standards in mind: https://prismjs.com/

require('prismjs/prism.js');
require('prismjs/plugins/normalize-whitespace/prism-normalize-whitespace.js');
require('@/src/js/vendors/plugins/prism.init.js');

require('./prismjs.scss');
